import React, { FC } from 'react';
import { Box, keyframes } from '@edreamsodigeo/prisma-design-system';
import { useNumberOfPassengers } from 'clientState/providers/SearchRequestProvider';
import AlternativeItineraryDoubleCardLayerCard from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayerCard/AlternativeItineraryDoubleCardLayerCard';
import BottomAlternativeItineraryDecorator from '../BottomAlternativeItineraryDecorator/BottomAlternativeItineraryDecorator';
import AlternativeItineraryDoubleCardLayerButtons from '../AlternativeItineraryDoubleCardLayerButtons/AlternativeItineraryDoubleCardLayerButtons';
import { AlternativeItineraryDoubleCardLayerBottomSectionProps } from './types';
import AlternativeItineraryDoubleCardBenefits from './AlternativeItineraryDoubleCardBenefits';
import AlternativeItineraryDoubleCardLayerSectionTitle from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayer/AlternativeDoubleCardLayerSectionTitle';
const AlternativeItineraryDoubleCardLayerBottomSection: FC<
  AlternativeItineraryDoubleCardLayerBottomSectionProps
> = ({
  valueProposition,
  valuePropositions,
  additionalInformation,
  discountAmount,
  itinerary,
  selectedItinerary,
  nonIssuable,
  showContinueButton = false,
  paddingTop = '1x_big',
  onContinue,
  onChange,
  overrideAction,
  trackingHandler,
  simpleUI = false,
}) => {
  const numPassengers = useNumberOfPassengers();

  const animation = keyframes`
  0% {
    transform: translateY(100%);
  }
  100%{
    transform: translateY(0);
  }
`;

  return (
    <Box
      sx={{
        backgroundColor: 'neutral.0',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        padding: '1x_big',
        paddingTop: paddingTop,
        animation: animation,
        animationDuration: '0.5s',
      }}
    >
      <AlternativeItineraryDoubleCardLayerSectionTitle
        valueProposition={valueProposition}
        valuePropositions={valuePropositions}
        itinerary={itinerary}
        selectedItinerary={selectedItinerary}
        nonIssuable={nonIssuable}
        discountAmount={discountAmount}
      />
      <Box paddingBottom="0">
        <AlternativeItineraryDoubleCardLayerCard
          isAlternativeItineraryOnModal
          itinerary={itinerary}
          nonIssuable={nonIssuable}
          isClickable={!showContinueButton || simpleUI}
          isAlternativeItinerary={true}
          isSelectedItinerary={false}
          hasAlternativeItineraryDecorator={true}
          onSelectAlternativeItinerary={onChange}
          overrideAction={overrideAction}
          trackingHandler={trackingHandler}
          onSelectOriginalItinerary={onContinue}
        />
        <BottomAlternativeItineraryDecorator
          itinerary={itinerary}
          additionalInformation={additionalInformation}
          valueProposition={valueProposition}
          valuePropositions={valuePropositions}
          discountAmount={discountAmount}
          selectedItinerary={selectedItinerary}
          numPassengers={numPassengers}
        />
      </Box>
      <AlternativeItineraryDoubleCardBenefits
        valuePropositions={valuePropositions}
        additionalInformation={additionalInformation}
        itinerary={itinerary}
        selectedItinerary={selectedItinerary}
        numPassengers={numPassengers}
        simpleUI={simpleUI}
      />
      {!simpleUI && (
        <AlternativeItineraryDoubleCardLayerButtons
          valueProposition={valueProposition}
          itinerary={itinerary}
          selectedItinerary={selectedItinerary}
          nonIssuable={nonIssuable}
          showContinueButton={showContinueButton}
          discountAmount={discountAmount}
          onContinue={onContinue}
          onChange={onChange}
        />
      )}
    </Box>
  );
};

export default AlternativeItineraryDoubleCardLayerBottomSection;
